<app-top-bar></app-top-bar>
<app-header></app-header>
<main class="main-content">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>

<app-cart-sidebar
  [isOpen]="cartService.isOpen()"
  [items]="cartService.items()"
  (close)="cartService.close()"
  (editPersonalization)="onEditPersonalization($event)">
</app-cart-sidebar>

<app-customizer-sidebar
  [isOpen]="showCustomizer"
  [image]="editImage"
  [options]="customizerOptions"
  (close)="showCustomizer = false"
  (saveCustomization)="onCustomizationSaved($event)">
</app-customizer-sidebar>

<!-- WhatsApp floating button -->
<a class="whatsapp-float" href="https://web.whatsapp.com/send?phone=51961465621&text=Hola%2C%20quiero%20comprar%20un%20producto" target="_blank" rel="noopener">
  <span class="whatsapp-tooltip">¡Escríbenos!</span>
  <img src="assets/images/whatsapp.png" alt="WhatsApp" />
</a>
